import { StyleFormat } from '../../../../../../backend/src/types/types';
import { Icon } from '@/new/components/icon';

interface DownloadFormatSelectorProps {
  onSelectFormat: (format: StyleFormat) => void;
}

export function DownloadFormatSelector({ onSelectFormat }: DownloadFormatSelectorProps) {
  const allFormats = [
    {
      id: StyleFormat.Table,
      label: 'Table',
      icon: <Icon className="lucide--table" />,
      color: 'text-green-600',
      text: 'Word or Excel',
    },
    {
      id: StyleFormat.Written,
      label: 'Written',
      icon: <Icon className="lucide--file-text" />,
      color: 'text-blue-600',
      text: 'Word',
    },
  ];

  return (
    <div className="flex flex-row justify-center gap-4 rounded-lg bg-transparent p-4">
      {allFormats.map((format) => (
        <div
          key={format.id}
          className={`flex w-full cursor-pointer flex-col items-center justify-center rounded-lg border border-gray-200 bg-gray-50/50 p-4 transition-all duration-300 hover:border-blue-300 hover:shadow-lg hover:shadow-blue-100/50`}
          onClick={() => onSelectFormat(format.id)}
        >
          <div
            className={`mb-3 flex h-12 w-12 items-center justify-center rounded-lg bg-gradient-to-br from-blue-50 to-blue-100/50 text-2xl text-blue-600 transition-all duration-300`}
          >
            {format.icon}
          </div>
          <span className="mb-0.5 font-serif text-base font-medium text-gray-900">{format.label}</span>
          <span className="text-center text-xs text-gray-500">{format.text}</span>
        </div>
      ))}
    </div>
  );
}
